import React from "react";
import ProConnectSection from "../../components/StudentWorld/ProConnect.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const ProConnect: React.FC = () => {
  return (
    <div>
       <MetaComponent
        title="ProConnect All-in-One Platform by Aptech - Digital Learning, Social Engagement, and Placements."
        desc="Join ProConnect by Aptech! View student projects, promote your centers, and engage in recruitment activities on this all-in-one platform."
        keywords="proconnect, digital learning, career opportunities."
      />
      <ProConnectSection />
    </div>
  );
}

export default ProConnect;
